'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function buildSvg(iconData) {
  var svgElements = iconData.map(function (prop, index) {
    // rename class key if it exists in prop.attributes to className as it throws an err in React
    // slight concern here mutating the obj coming in, but doesn't seem to cause an issue
    var safeAttrs = prop.attributes;
    if (safeAttrs["class"]) {
      safeAttrs.className = safeAttrs["class"];
      delete safeAttrs["class"];
    }
    var overrideConfig = {
      fill: safeAttrs.fill === 'none' ? safeAttrs.fill : '',
      stroke: safeAttrs.stroke === 'transparent' ? safeAttrs.stroke : ''
    };
    var mergedConfig = _objectSpread(_objectSpread({}, safeAttrs), overrideConfig);
    if (prop.name === 'path') {
      return /*#__PURE__*/React__default.createElement("path", _extends({}, mergedConfig, {
        key: "path-".concat(index)
      }));
    } else if (prop.name === 'circle') {
      return /*#__PURE__*/React__default.createElement("circle", _extends({}, safeAttrs, {
        key: "circle-".concat(index)
      }));
    } else if (prop.name === 'g') {
      return /*#__PURE__*/React__default.createElement("g", _extends({}, safeAttrs, {
        key: "g-".concat(index)
      }), buildSvg(prop.children));
    } else if (prop.name === 'rect') {
      return /*#__PURE__*/React__default.createElement("rect", _extends({}, safeAttrs, {
        fill: "",
        key: "rect-".concat(index)
      }));
    } else {
      return null;
    }
  });
  return svgElements;
}

module.exports = buildSvg;
